module.exports = __webpack_public_path__ + "img/CLAMP-A.c8aeecb4.svg";